import { useEffect, useState } from "react";
import { _ProductionOrderRemission } from "../../../core/services/dataBean/EntityCatalogVdos";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable, MASK_DATE } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { InputDate } from "../../theme/Input/InputDate";
import useModal, { MODAL_XL } from "../../theme/Component/hooks/useModal";
import { _DocumentFactory } from "../../../core/services/dataBean/EntityCatalog";
import { ErrorList } from "../../theme/Component/ErrorList";
import { DocumentViewer } from "../../theme/Component/DocumentViewer";

interface Props {
    idProductionOrder: any;
    productionOrderDate: any;
}

export const ProductionOrderRemission = ({ idProductionOrder, productionOrderDate }: Props) => {

    const { bean, setBean, lista, setLista, instance, deleteItemVoid, update, handleChange } = useDataBean(_ProductionOrderRemission);
    const modalDoc = useModal("Documento Contable", MODAL_XL);
    const doc = useDataBean(_DocumentFactory);

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idProductionOrder, productionOrderDate])

    const getLista = () => {

        instance.getProductionOrderRemissionCatalogByProductionOrder(idProductionOrder, productionOrderDate).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        setBean({
            IDProductionOrder: idProductionOrder,
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        deleteItemVoid(bean.IDProductionOrderRemission).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDProductionOrderRemission', visible: true },
        { title: 'Producto', property: 'ProductName', visible: true },
        { title: 'Unidad de Medida', property: 'MeasurementUnitCode', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Valor Total', property: 'TotalValue', visible: true },
        { title: 'Almacén', property: 'StoreName', visible: true },
        { title: 'Lote', property: 'IDLot', visible: true },
        { title: 'Cuenta Contable Salida', property: 'AccountantIDName', visible: true },
        { title: 'Mnemonic', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true },
        { title: 'Fecha Documento', property: 'DocumentDate', visible: true, mask: MASK_DATE },
        { title: 'Estado', property: 'State', visible: true },
    ]

    const [msgList, setMsgList] = useState<any>([]);

    const listaBotones = () => {
        const botones = [
            {
                titulo: 'Ver Documento', icono: 'ri-eye-line', visible: true, evento: () => {
                    doc.instance.getAccountantDocumentByLocation(bean.IDDocument, bean.Since).then(
                        (resp) => {

                            doc.setLista(resp.DocumentURL)
                            modalDoc.open()
                            setMsgList(resp.MsgList);
                        }
                    )
                }
            },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Ver Traslados de Producto Terminado a Almacén">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} ></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">

                            <div className="col-md-12">
                                <label>Mnemonic</label>
                                <input type="text" name="Mnemonic" className="form-control" value={bean.Mnemonic} onChange={handleChange} />
                            </div>
                            <div className="col-md-12">
                                <label>Consecutivo</label>
                                <input type="text" name="Consecutive" className="form-control" value={bean.Consecutive} onChange={handleChange} />
                            </div>

                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.Name}</strong>
                    </ModalConfirm>

                    <Modal modal={modalDoc.modal} updateModal={modalDoc.setModal} >
                        <div className="row">
                            <div className="col">
                                {msgList.length > 0 &&
                                    <ErrorList lista={msgList} />
                                }
                                {msgList.length === 0 && lista.length > 0 &&
                                    <DocumentViewer key={doc.lista} list={doc.lista} />
                                }
                            </div>
                        </div>
                    </Modal>
                </div>

            </div>
        </BasicPage>
    )
}